// authconfig contains the configuration settings needed for the
// Azure Active Directory (Azure AD) authentication library to function properly.

import { Configuration, PopupRequest, LogLevel } from '@azure/msal-browser';
// import { UserAgentApplication } from 'msal';

export const msalConfig: Configuration = {
  auth: {
    clientId: `${process.env.REACT_APP_CLIENT_ID}`, // The Application (client) ID that the Azure portal - App registrations experience assigned to your app
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AUTH_CODE}/`, // The URL of the Azure AD endpoint
    redirectUri: `${process.env.REACT_APP_REDIRECT_URI}`, // The redirect URI where Azure AD will send the tokens
    // navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
    iframeHashTimeout: 60000, // Timeout for iframe-based navigation
    windowHashTimeout: 60000, // Timeout for popup-based navigation
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.log(logLevel + ' ' + message);
      },
      logLevel: LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ['User.Read'],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

// export const msalApp = new UserAgentApplication({
//   auth: {
//     clientId: `${process.env.REACT_APP_CLIENT_ID}`,
//     authority: 'https://login.microsoftonline.com/f3211d0e-125b-42c3-86db-322b19a65a22',
//     redirectUri: `${process.env.REACT_APP_REDIRECT_URI}`,
//   },
//   cache: {
//     cacheLocation: 'sessionStorage',
//     //storeAuthStateInCookie: isIE()
//   },
// });
